import { createContext, useContext, useEffect, useRef, useState } from "react";
import { useAuth } from "@clerk/react";
import { http } from "@/lib/api";

const Ctx = createContext(null);
const load = (k, d) => JSON.parse(localStorage.getItem(k) || JSON.stringify(d));

const useWishSync = (wish, setWish) => {
  const { isSignedIn, getToken } = useAuth();
  const ready = useRef(false);
  useEffect(() => {
    ready.current = false;
    if (!isSignedIn) return;
    (async () => {
      const h = { headers: { Authorization: `Bearer ${await getToken()}` } };
      const { data } = await http.get("/wishlist", h);
      const merged = [...new Set([...data.ids, ...load("rv_wish", [])])];
      setWish(merged);
      ready.current = true;
      if (merged.length !== data.ids.length) await http.put("/wishlist", { ids: merged }, h);
    })().catch(() => {});
  }, [isSignedIn]); // eslint-disable-line
  useEffect(() => {
    if (!isSignedIn || !ready.current) return;
    getToken().then((t) => http.put("/wishlist", { ids: wish }, { headers: { Authorization: `Bearer ${t}` } })).catch(() => {});
  }, [wish]); // eslint-disable-line
};

export function StoreProvider({ children }) {
  const [cart, setCart] = useState(() => load("rv_cart", []));
  const [wish, setWish] = useState(() => load("rv_wish", []));
  const [open, setOpen] = useState(false);
  const [settings, setSettings] = useState(null);
  useEffect(() => { localStorage.setItem("rv_cart", JSON.stringify(cart)); }, [cart]);
  useEffect(() => { localStorage.setItem("rv_wish", JSON.stringify(wish)); }, [wish]);
  useEffect(() => { http.get("/settings").then((r) => setSettings(r.data)); }, []);
  useWishSync(wish, setWish);

  const add = (p, v, qty = 1, silent) => {
    setCart((c) => {
      const f = c.find((i) => i.sku === v.sku);
      const max = v.stock;
      if (f) return c.map((i) => (i.sku === v.sku ? { ...i, qty: Math.min(max, 10, i.qty + qty) } : i));
      return [...c, { sku: v.sku, product_id: p.id, slug: p.slug, name: p.name, price: p.price, image: p.images?.[0], color: v.color, size: v.size, qty: Math.min(qty, max), max }];
    });
    if (!silent) setOpen(true);
  };
  const setQty = (sku, q) => setCart((c) => (q < 1 ? c.filter((i) => i.sku !== sku) : c.map((i) => (i.sku === sku ? { ...i, qty: Math.min(q, i.max, 10) } : i))));
  const toggleWish = (id) => setWish((w) => (w.includes(id) ? w.filter((x) => x !== id) : [...w, id]));
  const count = cart.reduce((s, i) => s + i.qty, 0);
  return <Ctx.Provider value={{ cart, add, setQty, clear: () => setCart([]), count, open, setOpen, wish, toggleWish, settings, setSettings }}>{children}</Ctx.Provider>;
}
export const useStore = () => useContext(Ctx);
